import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { PitchFormData } from "../../../components/Models/PitchFormData";

interface UseGetPitchProps {
  id: number;
  enabled?: boolean;
}

interface PitchData {
  pitch: PitchFormData;
}

interface PitchResponse {
  pitchViewModel: PitchData;
}

export function useGetPitch({ id, enabled = true }: UseGetPitchProps) {
  return useQuery({
    enabled,
    queryKey: ["pitch", id],
    queryFn: async () => {
      return axiosInstance<PitchResponse>(
        getAPIURL(`/Pitch/get-pitch-by-id/${id}?id=${id}`)
      ).then((response) => response.data);
    },
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      // Do not retry for client errors
      return status !== 400 && failureCount < 3;
    },
  });
}
